import { event } from "vue-analytics";
import moment from "@/utils/moment";

function eventsMap(type) {
  return {
    testFlowPickProfessional: testPickProfessional,
    testFlowCreateOrder: testCreateOrder,

    buyAddress: addressSelected,
    buySearchProfessionals: searchAvailableProfessionals,
    buySearchProfessionalsSugestion: searchAvailableProfessionalsSugestion,
    buySearchProfessionalsResponse: searchProfessionalsResponse,
    buySearchProfessionalResponse: searchProfessionalResponse,
    buyProfessionalSelection: professionalSelection,
    buyOrderCreation: orderCreation,
    buyOrderCreationError: orderCreationError,
    buyOrderOfferCreation: orderOfferCreation
  }[type];
}

function addressSelected() {
  return "Compra:Endereco:selecionou o endereco";
}

function orderOfferCreation(payload) {
  return buildSearchProfessionalsString(payload, "Compra:oferta:criacao");
}

function searchAvailableProfessionals(payload) {
  return buildSearchProfessionalsString(payload, "Compra:diaespecifico:buscar");
}

function searchAvailableProfessionalsSugestion(payload) {
  const basePayload = "Compra:diaespecifico:busca:sugestao";

  const keyMaps = {
    date: "dia",
    duration: "duração",
    initialHour: "horainicial",
    professionalName: "nome"
  };

  return Object.keys(payload).reduce((gaEventPayload, filter) => {
    if (payload[filter]) {
      if (filter === "date") {
        gaEventPayload += `:${keyMaps[filter]}=${moment(payload[filter]).format(
          "YYYY/MM/DD"
        )}`;

        const daysOfPrecedence = moment(payload[filter])
          .startOf("day")
          .diff(moment().startOf("day"), "days");
        gaEventPayload += `:diasdeantecedencia=${daysOfPrecedence}`;
      } else {
        gaEventPayload += `:${keyMaps[filter]}=${payload[filter]}`;
      }
    }

    return gaEventPayload;
  }, basePayload);
}

function searchProfessionalsResponse(payload) {
  if (!payload.address) {
    return;
  }

  let basePayload = `Compra:${
    payload.orderOffer ? "oferta" : "diaespecifico"
  }:profissional`;

  basePayload += `:numerodisponiveis=${payload.professionalCount}`;
  basePayload += `:cidade=${payload.address.district.city.display_name}`;
  basePayload += `:bairro=${payload.address.district.display_name}`;

  const keyMaps = {
    date: "dia",
    duration: "duração",
    initialHour: "horainicial",
    professionalName: "nome"
  };

  return Object.keys(payload.filters).reduce((gaEventPayload, filter) => {
    if (payload.filters[filter]) {
      if (filter === "date") {
        gaEventPayload += `:${keyMaps[filter]}=${moment(
          payload.filters[filter]
        ).format("YYYY/MM/DD")}`;

        const daysOfPrecedence = moment(payload.filters[filter])
          .startOf("day")
          .diff(moment().startOf("day"), "days");
        gaEventPayload += `:diasdeantecedencia=${daysOfPrecedence}`;
      } else {
        gaEventPayload += `:${keyMaps[filter]}=${payload.filters[filter]}`;
      }
    }

    return gaEventPayload;
  }, basePayload);
}

function searchProfessionalResponse(payload) {
  let basePayload = "Compra:diaespecifico:profissional:disponivel";

  basePayload += `:nome=${payload.firstName} ${payload.lastName}`;
  basePayload += `:nota=${payload.rating}`;
  basePayload += `:limpezas=undefined`;

  return basePayload;
}

function professionalSelection(payload) {
  let basePayload = "Compra:profissional";

  basePayload += `:selecionado=${payload.firstName} ${payload.lastName}`;

  return basePayload;
}

function orderCreation(payload) {
  let basePayload = `Compra:${
    payload.orderOffer ? "oferta" : "diaespecifico"
  }:finalizar`;

  basePayload += `profissional=${payload.professional.account.first_name} ${
    payload.professional.account.last_name
  }`;
  basePayload += `:nota=${payload.professional.rating}`;
  basePayload += `:limpezas=undefined`;
  basePayload += `:cidade=${payload.address.district.city.display_name}`;
  basePayload += `:bairro=${payload.address.district.display_name}`;

  const keyMaps = {
    date: "dia",
    duration: "duração",
    initialHour: "horainicial",
    professionalName: "nome"
  };

  return Object.keys(payload.filters).reduce((gaEventPayload, filter) => {
    if (payload.filters[filter]) {
      if (filter === "date") {
        gaEventPayload += `:${keyMaps[filter]}=${moment(
          payload.filters[filter]
        ).format("YYYY/MM/DD")}`;

        const daysOfPrecedence = moment(payload.filters[filter])
          .startOf("day")
          .diff(moment().startOf("day"), "days");
        gaEventPayload += `:diasdeantecedencia=${daysOfPrecedence}`;
      } else {
        gaEventPayload += `:${keyMaps[filter]}=${payload.filters[filter]}`;
      }
    }

    return gaEventPayload;
  }, basePayload);
}

function orderCreationError(payload) {
  let basePayload = "Compra:diaespecifico:finalizar:error";

  basePayload += `profissional=${payload.professional.account.first_name} ${
    payload.professional.account.last_name
  }`;
  basePayload += `:nota=${payload.professional.rating}`;
  basePayload += `:limpezas=undefined`;
  basePayload += `:cidade=${payload.address.district.city.display_name}`;
  basePayload += `:bairro=${payload.address.district.display_name}`;

  const keyMaps = {
    date: "dia",
    duration: "duração",
    initialHour: "horainicial",
    professionalName: "nome"
  };

  return Object.keys(payload.filters).reduce((gaEventPayload, filter) => {
    if (payload.filters[filter]) {
      if (filter === "date") {
        gaEventPayload += `:${keyMaps[filter]}=${moment(
          payload.filters[filter]
        ).format("YYYY/MM/DD")}`;

        const daysOfPrecedence = moment(payload.filters[filter])
          .startOf("day")
          .diff(moment().startOf("day"), "days");
        gaEventPayload += `:diasdeantecedencia=${daysOfPrecedence}`;
      } else {
        gaEventPayload += `:${keyMaps[filter]}=${payload.filters[filter]}`;
      }
    }

    return gaEventPayload;
  }, basePayload);
}

function buildSearchProfessionalsString(payload, base) {
  const keyMaps = {
    date: "dia",
    duration: "duração",
    initialHour: "horainicial",
    professionalName: "nome"
  };

  return Object.keys(payload).reduce((gaEventPayload, filter) => {
    if (payload[filter]) {
      if (filter === "date") {
        gaEventPayload += `:${keyMaps[filter]}=${moment(payload[filter]).format(
          "YYYY/MM/DD"
        )}`;

        const daysOfPrecedence = moment(payload[filter])
          .startOf("day")
          .diff(moment().startOf("day"), "days");
        gaEventPayload += `:diasdeantecedencia=${daysOfPrecedence}`;
      } else {
        gaEventPayload += `:${keyMaps[filter]}=${payload[filter]}`;
      }
    }

    return gaEventPayload;
  }, base);
}

function testPickProfessional(payload) {
  let basePayload = "fluxo:teste:cliente_";

  basePayload += payload.newUser ? "novo:" : "recorrente:";

  return basePayload + payload.event;
}

function testCreateOrder(payload) {
  let basePayload = "fluxo:teste:cliente_";

  basePayload += payload.newUser ? "novo:" : "recorrente:";

  return basePayload + payload.event;
}

function eventPayload(eventType, payload) {
  const e = eventsMap(eventType);

  return e(payload);
}

const sendEvent = (
  eventType,
  payload = [],
  source = "cliente",
  action = "click"
) => {
  const query = eventPayload(eventType, payload);
  if (!query) {
    return;
  }
  event(source, action, query);
};

export { sendEvent };



// WEBPACK FOOTER //
// ./src/utils/analytics.js